/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from './selector-control.component';
import * as import4 from '../../ui-elements/touchable.directive';
import * as import5 from '@angular/common';
const styles_SelectorControlComponent:any[] = ([] as any[]);
export const RenderType_SelectorControlComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_SelectorControlComponent,
  data: {}
}
);
function View_SelectorControlComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'selector-control-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.label,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
export function View_SelectorControlComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[
      [
        'class',
        'selector-control'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.SelectorControlComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.select($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(4210688,(null as any),0,import4.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'selector-control-body'
      ]
      ],[[
        2,
        'disabled',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'selector-control-body-indicator'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'checkbox',
      'radio',
      'selected'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SelectorControlComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import3.SelectorControlComponent = v.component;
    const currVal_1:any = 'selector-control-body-indicator';
    const currVal_2:any = ck(v,7,0,(co.type === co.SelectorType.CHECKBOX),(co.type === co.SelectorType.RADIO),co.selected);
    ck(v,6,0,currVal_1,currVal_2);
    const currVal_3:any = co.label;
    ck(v,11,0,currVal_3);
  },(ck,v) => {
    var co:import3.SelectorControlComponent = v.component;
    const currVal_0:any = co.disabled;
    ck(v,3,0,currVal_0);
  });
}
function View_SelectorControlComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-selector-control',([] as any[]),[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'touched',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),View_SelectorControlComponent_0,RenderType_SelectorControlComponent)),
    import0.ɵdid(49152,(null as any),0,import3.SelectorControlComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).touched;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export const SelectorControlComponentNgFactory:import0.ComponentFactory<import3.SelectorControlComponent> = import0.ɵccf('woa-selector-control',import3.SelectorControlComponent,View_SelectorControlComponent_Host_0,{
  type: 'type',
  selected: 'selected',
  label: 'label',
  translationParams: 'translationParams',
  disabled: 'disabled',
  touched: 'touched'
}
,{
  selectedChange: 'selectedChange',
  onSelect: 'onSelect'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/inputs/selector-control/selector-control.component.ngfactory.ts